<template>
  <v-dialog
      ref="dialog"
      v-model="dialog"
      :return-value.sync="date"
      persistent
      width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-btn fab small color="blue darken-2" v-on="on">
        <v-icon v-text="'mdi-calendar'"/>
      </v-btn>
    </template>
    <v-date-picker v-model="date" scrollable color="teal">
      <v-spacer></v-spacer>
      <v-btn text color="blue" @click="dialog = false">Cancel</v-btn>
      <v-btn text color="blue" @click="save">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import moment from 'moment';

export default {
  name: 'DateSelector',
  props: {
    value: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      dialog: false
    }
  },
  watch: {
    value: {
      handler() {
        if (this.value !== this.date) {
          this.date = this.value;
        }
      },
      immediate: true
    }
  },
  methods: {
    save() {
      this.$refs.dialog.save(this.date);
      this.$emit('input', this.date);
    }
  }
}
</script>

<style scoped>

</style>
